import { AccountAlertOutlineIcon } from './AccountAlertOutlineIcon';

/**
 * author: Coffeemate
 * id 858CE593-C905-42C6-ABA5-99379EBD95AE
 * name account-alert-outline
 * version: 3.0.39
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/account-alert-outline.svg
 * tags
 * - Account / User 
 * - Alert / Error 
 */
export const UserAlertOutlineIcon = AccountAlertOutlineIcon;
export default UserAlertOutlineIcon